import { Container } from "react-bootstrap";
import sealingbanner from "../assets/img/inner-banner/Sealing-Service.webp";
import sealingbannerMobile from "../assets/img/mobile-banner/Sealing-Service.webp";

import online from "../assets/img/SERVICES.jpg";
import hologram from "../assets/img/HOLOGRAM-SECURITY.jpg";

import "./ServiceDetails.css";
import { Link } from "react-router-dom";
import {
  MdKeyboardDoubleArrowRight,
  MdOutlineKeyboardDoubleArrowRight,
} from "react-icons/md";
import { IoCheckmarkDone } from "react-icons/io5";
import { Helmet } from "react-helmet";

export default function Sealing() {
  return (
    <>
      <Helmet>
        {/* Meta tags */}
        <title>
          Best Diamond Sealing Services in India | Sreehari Diamond Laboratory{" "}
        </title>
        <meta
          name="description"
          content="Protect your diamond certification with our advanced sealing services, ensuring authenticity, safety, and long-term preservation of your diamond."
        />
        <meta
          name="keywords"
          content="lab grown diamond certification, best diamond certification in india, Gemstone Identification Lab, Diamond, Gemological Laboratory, Diamond Testing Lab, Diamond Sealing service, Best diamond services"
        />
        {/* OG tags */}
        <meta
          property="og:title"
          content="Best Diamond Sealing Services in India | Sreehari Diamond Laboratory"
        />
        <meta
          property="og:description"
          content="Protect your diamond certification with our advanced sealing services, ensuring authenticity, safety, and long-term preservation of your diamond."
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:url"
          content="https://sreeharidiamondlab.com/diamond-sealing-service"
        />
        <meta
          property="og:image"
          content="https://sreeharidiamondlab.com/static/media/Sealing-Service.97a55f04ad052497592e.webp"
        />
        <meta property="og:site_name" content="sreehari diamond laboratory" />
        {/* Twitter tags */}
        <meta
          name="twitter:title"
          content="Best Diamond Sealing Services in India | Sreehari Diamond Laboratory"
        />
        <meta
          name="twitter:description"
          content="Protect your diamond certification with our advanced sealing services, ensuring authenticity, safety, and long-term preservation of your diamond."
        />
        <meta
          name="twitter:image"
          content="https://sreeharidiamondlab.com/static/media/Sealing-Service.97a55f04ad052497592e.webp"
        />
        <meta name="twitter:site" content="sreehari diamond laboratory" />
        <link
          rel="canonical"
          href="https://sreeharidiamondlab.com/diamond-sealing-service"
        />{" "}
      </Helmet>
      <section>
        <Container fluid className="bannersection position-relative p-0">
          <img
            src={window.innerWidth > 568 ? sealingbanner : sealingbannerMobile}
            alt="Service banner"
            className="w-100  h-100 object-fit-cover about-banner-img"
          />
          <div className="textoverlay pt-5 d-flex flex-column justify-content-center align-items-center position-absolute top-0 w-100 h-100 text-center"></div>
        </Container>
      </section>
      <section className="hologram-section section-spacing-x section-spacing-y pb-0">
        <div className="container-fluid">
          <div className="row">
            <h1 className="heading mb-3 text-center">
              Trusted Sealing Service for Verified Diamonds
            </h1>
          </div>
          <p>
            Our Sealing Service offers secure, tamper-proof encapsulation of
            certified diamonds and gemstones. Each stone is sealed within a
            durable, transparent holder that preserves its authenticity,
            protects against damage, and prevents any tampering. This service
            provides peace of mind to buyers and sellers by ensuring the gem’s
            grading and certification remain intact and verifiable at all times.
            Ideal for preserving the value and integrity of your precious
            stones, our sealing process is a trusted solution widely recognized
            in the jewelry industry.{" "}
          </p>
          <div className="content-para">
            <p>
              <b>
                Our sealing has been created to hold the diamond in place and
                show its beauty:
              </b>
            </p>
            <p>
              <IoCheckmarkDone /> A transparent, colorless, scratch-resistant
              polyester 'window' makes sure that the diamond can be seen with
              all its brilliance and fire.
            </p>
            <p>
              <IoCheckmarkDone />
              The diamond is protected against any damage due to the strong but
              flexible material from which the sealing packet is made
            </p>
            <p>
              <IoCheckmarkDone /> The sealing is easily open by scissors are
              needed - but once it is opened, it cannot be resealed and
              therefore cannot be tampered with or replaced
            </p>
            <p>
              <IoCheckmarkDone /> Ensures that a diamond sent out for sale to a
              potential client cannot be changed or replaced, thus providing you
              with complete security and peace of mind.
            </p>
          </div>
          <div className="contact-us-button mt-lg-4 mb-lg-3 mb-4">
            <Link to="/contact-us">
              Contact Us <MdOutlineKeyboardDoubleArrowRight />
            </Link>
          </div>
        </div>
      </section>

      <section className="section-spacing-x">
        <div className="container-fluid">
          <div className="row mb-5">
            <h2 className="text-center mb-4 heading">Other Services</h2>
            <div className="col-lg-4 mb-lg-0 mb-3">
              <div className="service-card text-center border rounded p-2 ">
                <div className="service-image mx-auto">
                  <img src={online} alt="service" className="img-fluid" />
                </div>
                <Link to={"/online-certificate-verification"}>
                  <h3 className="mt-0">Online Service</h3>
                </Link>
                <p className="mt-0">
                  With our Online Service, you can easily submit your gemstones
                  remotely and receive detailed grading reports without visiting
                  the lab.{" "}
                </p>
                <div className="service-read-more mb-3">
                  <Link to={"/online-certificate-verification"}>
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="service-card text-center border rounded p-2">
                <div className="service-image mx-auto">
                  <img
                    src={hologram}
                    alt="Diamond Hologram Security Stickers | Sreehari Diamond Laboratory"
                    className="img-fluid"
                  />
                </div>
                <Link to="/diamond-hologram-stickers">
                  <h3 className="mt-0">Hologram Security</h3>
                </Link>

                <p className="mt-0">
                  Our innovative Diamond Hologram Service adds a secure,
                  anti-counterfeit layer to every certified diamond,
                  guaranteeing easy verification.{" "}
                </p>
                <div className="service-read-more mb-3">
                  <Link to="/diamond-hologram-stickers">
                    Read More
                    <MdKeyboardDoubleArrowRight />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
